import type { Permission } from '../permissions.dto';

export type PagePermissions = Extract<
  Permission,
  | `PROFILE_VIEW`
  | 'DASHBOARD_VIEW'
  | 'ORDERS_VIEW'
  | 'ORDERS_CREATE'
  | 'APPLICATIONS_VIEW'
  | 'TRANSACTIONS_VIEW'
>;

const PAGE_PERMISSIONS = new Set<Permission>([
  'PROFILE_VIEW',
  'DASHBOARD_VIEW',
  'ORDERS_VIEW',
  'ORDERS_CREATE',
  'APPLICATIONS_VIEW',
  'TRANSACTIONS_VIEW',
] satisfies PagePermissions[]);

export const isPagePermission = (
  permission: Permission
): permission is PagePermissions => PAGE_PERMISSIONS.has(permission);
